import { useQuery } from '@tanstack/react-query';
import { workspaceService } from '@/modules/workspace/api/workspace.service';
import { useIsPlatformAdmin } from '@/shared/hooks/use-is-platform-admin';

/** Cache keys for the signed-in user's switchable workspaces. */
export const workspaceQueryKeys = {
    all:  ['workspaces'] as const,
    list: () => [...workspaceQueryKeys.all, 'list'] as const,
} as const;

/**
 * The workspaces the current user can switch into. Rarely changes (only when
 * the user accepts a new invite), so cache aggressively — the switcher reads
 * from cache on every sidebar render.
 */
export function useWorkspaces() {
    const isPlatformAdmin = useIsPlatformAdmin();
    return useQuery({
        queryKey: workspaceQueryKeys.list(),
        queryFn:  () => workspaceService.list(),
        staleTime: 5 * 60_000,
        // The admin has no sibling workspaces to switch into; with this off the
        // card falls back to its static label, which is what it showed anyway.
        enabled: !isPlatformAdmin,
    });
}
